import {removeUserLastConnectionMethodCookie} from '../../auth/business/persistData'
import axios from 'axios'
import {logAndCaptureErrorMessage} from '../../utils/logging/errorHandlers'

import {UserType} from '../types'

/**
 * Authenticated axios instance
 */
export const authAxios = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
})

/**
 * EP that goes over backend and updates users auth0 metadata
 */
export const updateUserMetadata = async (req: UserType['userMetaData']) => {
  try {
    const token = await window.authClient.getTokenSilently()
    if (token)
      authAxios.defaults.headers.common.Authorization = `Bearer ${token}`
    await authAxios.post('/api/user/metadata', JSON.stringify(req))
    removeUserLastConnectionMethodCookie()
  } catch (error) {
    logAndCaptureErrorMessage(error)
  }
}
